import { render, staticRenderFns } from "./booking-date.vue?vue&type=template&id=645c5b24&"
import script from "./booking-date.vue?vue&type=script&lang=js&"
export * from "./booking-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports